// Название query параметра url в значении которого лежит поисковая фраза. Например http://localhost:3000/Mobile/Hello!/release%20notes?query=lightbox
export const SEARCH_QUERY_PARAM_TITLE = 'query';